"use client";

const BlogCard = ({
  title,
  cover_image,
  short_description,
  category,
  sub_category,
}) => {
  const parseArrayLikeString = (value) => {
    if (typeof value !== "string") return null;
    let current = value.trim();
    for (let i = 0; i < 2; i += 1) {
      if (!(current.startsWith("[") && current.endsWith("]"))) break;
      try {
        const parsed = JSON.parse(current);
        if (Array.isArray(parsed)) return parsed;
        if (typeof parsed === "string") {
          current = parsed.trim();
          continue;
        }
      } catch {
        break;
      }
    }
    return null;
  };
  const toArray = (value) => {
    if (Array.isArray(value)) return value.filter(Boolean).map((item) => String(item));
    if (!value) return [];
    const parsed = parseArrayLikeString(value);
    if (parsed) return parsed.filter(Boolean).map((item) => String(item));
    return [String(value)];
  };
  const categoryList = toArray(category);
  const subCategoryList = toArray(sub_category);
  const categoryText = [
    categoryList.length ? categoryList.join(", ") : "",
    subCategoryList.length ? subCategoryList.join(", ") : "",
  ]
    .filter(Boolean)
    .join(" / ");

  return (
    <div className="blog-card">
      <div className="blog-card-image">
        {cover_image ? (
          <img
            src={cover_image}
            alt={title}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full bg-gray-200 flex items-center justify-center">
            <span>{title}</span>
          </div>
        )}
      </div>

      <div className="blog-card-content">
        <div className="text-sm font-medium text-gray-500">
          {categoryText || "Uncategorized"}
        </div>
        <h3 className="text-xl font-bold mt-2">{title}</h3>
        <p className="text-gray-600 mt-2">{short_description}</p>
      </div>
    </div>
  );
};

export default BlogCard;
